import React, { useMemo } from 'react';
import Image from "../../../../Image";
import landingPageImg from "../../../../../assets/composites_background.jpg";
import styles from './StudentImages.module.sass'
import PreviewImage from '../../../../PreviewImage'
import TopHeavyMarkup from './layouts/TopHeavyMarkup';

const Wrapper = ({ children, school, student }) => {
  return (
    <div className={styles.container}>
      <p className={styles.schoolName}>
        {school.name}
      </p>
      <p className={styles.studentName}>
        {student.fullName()}
      </p>
      <Image src={landingPageImg} alt="Purchase Composite Image" />
      {children}
    </div>
  );
};

export const StudentImages = ({ studentImages, background, student, school }) => {
  if (studentImages.length <= 4) {
    return (
      <Wrapper school={school} student={student}>
        <div className={styles.imageContainer}>
          <div className={styles.imageRow}>
            {studentImages.map((image) => (
              <div className={styles.imageSection} style={{ width: `${100 / studentImages.length}%`}}>
                <PreviewImage
                  foregroundUrl={image.watermarkUrl}
                  backgroundUrl={background.imageUrl}
                  classes={styles.image}
                />
                <p className={styles.season}>
                  {image.folder.match(/\d/g).join('')}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Wrapper>
    );
  }

  if (studentImages.length % 2 === 1 || studentImages.length === 6) {
    return (
      <Wrapper school={school} student={student}>
        <TopHeavyMarkup studentImages={studentImages} background={background} />
      </Wrapper>
    );
  }

  const offset = studentImages.length / 2;

  // Two row markup
  return (
    <Wrapper school={school} student={student}>
      <div className={`${styles.imageContainer} ${styles.limitImageWidth}`}>
        <div className={styles.imageRow}>
          {studentImages.slice(0, offset).map((image) => (
            <div className={styles.imageSection}>
              <PreviewImage
                foregroundUrl={image.watermarkUrl}
                backgroundUrl={background.imageUrl}
                classes={styles.image}
              />
              <p className={styles.season}>
                {image.folder.match(/\d/g).join('')}
              </p>
            </div>
          ))}
        </div>
        <div className={styles.imageRow}>
          {studentImages.slice(offset, studentImages.length).map((image) => (
            <div className={styles.imageSection}>
              <PreviewImage
                foregroundUrl={image.watermarkUrl}
                backgroundUrl={background.imageUrl}
                classes={styles.image}
              />
              <p className={styles.season}>
                {image.folder.match(/\d/g).join('')}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  )
}

export default StudentImages
